import { useState, useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { HomepageWrapper } from './styles';
import { fetchPractitioners } from '../../../redux/reducers/practitioners.reducer';
import PopupModal from '../../../components/PopupModal';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import FeaturesSection from './components/FeaturesSection';
import HypnotherapySection from './components/HypnotherapySection';
import JourneySection from './components/JourneySection';
import ExpectationsSection from './components/ExpectationsSection';
import PricingSection from './components/PricingSection';
import StatisticsSection from './components/StatisticsSection';
import TestimonialsSection from './components/TestimonialsSection';
import { FINAL_CTA } from './constants';
import StartVideoConsultation from '../../../components/StartVideoConsultation';
import { PageWrapper } from '../../../components/Layouts/PageWrapper';
import Seo from '../../../components/Seo';
import { buildOrganizationSchema } from '../../../utils/seoBuilders';
import { openSimplePracticeConsultation } from '../../../utils/simplePractice';

const Splash = () => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [name] = useState('');
  const [percentage] = useState('');

  useEffect(() => {
    dispatch(fetchPractitioners());
  }, [dispatch]);

  const handleClose = () => setOpen(false);

  return (
    <PageWrapper>
      {/* The site-wide entity graph lives here; other pages reference it by @id. */}
      <Seo schema={buildOrganizationSchema()} />
      <HomepageWrapper className="homepage">
        <PopupModal open={open} handleClose={handleClose} name={name} percentage={percentage} />
        <HeroSection />
      </HomepageWrapper>

      <BenefitsSection />
      <FeaturesSection />
      <JourneySection />
      <HypnotherapySection />
      <ExpectationsSection />
      <PricingSection />
      <StatisticsSection />

      <TestimonialsSection />
      <StartVideoConsultation
        bgImg={FINAL_CTA.backgroundImage}
        title={FINAL_CTA.title}
        subtitle={FINAL_CTA.subtitle}
        btnText={FINAL_CTA.buttonText}
        onButtonClick={openSimplePracticeConsultation}
      />
    </PageWrapper>
  );
};

export default Splash;
